import createRouter from "router5";
import browserPlugin from "router5/plugins/browser";
import listenersPlugin from "router5/plugins/listeners";

import { routes } from "modules/routing/routes";

export const buildRouter = () =>
  createRouter(routes, { defaultRoute: "index" })
    .usePlugin(browserPlugin({ useHash: false }))
    .usePlugin(listenersPlugin());



// WEBPACK FOOTER //
// ./src/modules/routing/build-router.js